import { Component, OnInit, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { AnalyticsService } from '@app/core/services/analytics.service';
import { AppService } from '@app/core/services/app.service';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class LandingPageComponent implements OnInit {
  private appService = inject(AppService);
  private readonly analyticsService = inject(AnalyticsService);

  public readonly acceptedEulaSignal = this.appService.acceptedEulaSignal;
  public logoVisible = signal(true);
  public imgUrl: string = "../../../assets/icons/icon-full.svg";

  ngOnInit(): void {
    setTimeout(() => this.logoVisible.set(false), 2500);
    setTimeout(() => {

      if (this.acceptedEulaSignal()) {
        this.goToExhibitions();
      } else {
        this.goToInstruction();
      }

    }, 2800);
  }

  private goToInstruction() {
    this.appService.navigateWithUrlSuffix('profile');
    this.analyticsService.trackEvent(
      'firstStart',
      'showInstruction'
    );
  }

  private goToExhibitions() {
    this.appService.setLanguage('de');
    this.appService.navigateWithUrlSuffix('exhibition');
  }

}
